// DAS-2159: React context providing per-ticker green/red signal data
// to ClickableTickerChip across all PA modals without prop drilling.
// Value shape: { [TICKER]: { hasGreen, greenReasons[], hasRed, redReasons[] } }

import { createContext } from 'react';

export const TickerSignalContext = createContext({});
